module.exports = function(dispatcher) {
  return function({minLength, fontId}) {
    dispatcher.dispatch({
      type: 'storeInitialsMinLength',
      minLength,
      fontId
    });
  };
};
